import React from "react";
import { FormActions } from "../app";
import { ServiceFormFields } from "./ServiceFormSections";

export function ServiceForm({
  formData,
  setFormData,
  categories,
  units,
  calculateMargin,
  editingService,
  onSubmit,
  onCancel,
}) {
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <ServiceFormFields
        formData={formData}
        setFormData={setFormData}
        categories={categories}
        units={units}
        calculateMargin={calculateMargin}
      />

      <FormActions
        cancelLabel="Cancelar"
        submitLabel={editingService ? "Actualizar" : "Crear Servicio"}
        onCancel={onCancel}
      />
    </form>
  );
}

export default ServiceForm;
